"use client";

import React from "react";
import { ChatButtonOption } from "../hooks/useChat";

interface ChatButtonsProps {
  options: ChatButtonOption[];
  onButtonClick: (option: ChatButtonOption) => void;
}

const ChatButtons: React.FC<ChatButtonsProps> = ({
  options,
  onButtonClick,
}) => {
  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div
      className="w-full flex flex-wrap gap-2 p-3 border-t border-gray-200"
      role="group"
      aria-label="Chat options"
    >
      {options.map((option) => (
        <button
          key={option.id}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={() => onButtonClick(option)}
          type="button"
          aria-label={option.text}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
};

export default ChatButtons;
